<template>
  <b-row>
    <b-col cols="8">

      <b-row>
        <b-card>
          <b-tabs>
            <b-tab
              id="tab-left-1"
              title="เรื่องร้องทุกข์"
            >
              <b-card
                title="ข้อมูลผู้ร้องทุกข์/ผู้ดำเนินการ"
                body-border-variant="primary"
                body-class="rounded"
              >

                <b-col cols="12">
                  <BasicDetail
                    v-for="item in complainData"
                    :key="item.id"
                    :data="item.operator"
                    :is-read-only="'1'"
                    @handle-edit-personal="operatorDetailBtnClicked"
                    @handle-delete-personal="operatorBtnDeleteClicked"
                  />
                </b-col>
              </b-card>

              <b-card
                title="ผู้มอบอำนาจ"
                body-border-variant="primary"
                body-class="rounded"
              >
                <b-col class="container text-right mt-n2" />
                <b-col
                  cols="12"
                  class=""
                >
                  <BasicDetail
                    v-for="item in complainData"
                    :key="item.id"
                    :data="item.attorney"
                    :is-read-only="'1'"
                    @handle-edit-personal="attorneyDetailBtnClicked"
                    @handle-delete-personal="attorneyBtnDeleteClicked"
                  />
                </b-col>
              </b-card>

              <b-card
                title="ผู้ประกอบธุรกิจ (ผู้ถูกร้องทุกข์)"
                body-border-variant="primary"
                body-class="rounded"
              >
                <b-col class="container text-right mt-n2" />
                <b-col cols="12">
                  <Company
                    v-for="item in complainData"
                    :key="item.id"
                    :company="item.company"
                    :edit="true"
                    @handleDetail="fillCompanyDetail"
                    @handleDeleteBtn="companyBtnDeleteClicked"
                  />
                </b-col>
              </b-card>

              <b-card
                title="รายละเอียดเรื่องร้องทุกข์"
                body-border-variant="primary"
                body-class="rounded"
              >
                <b-col class="container text-right mt-n2 mb-2" />

                <ComplainDetail
                  v-if="complainData.length > 0"
                  :is-read-only="'1'"
                  :data-d="complainData[0].details"
                  @handle-deleted="onDetailBtnDeleteClicked"
                />

              </b-card>

            </b-tab>
            <TabAttachFiles />
          </b-tabs>
        </b-card>
      </b-row>

    </b-col>
    <RightTab />

    <ModalPersonal
      ref="modalPersonalComponent"
      :personal="modalPersonal"
      @handle-submit="onModalSubmitData"
    />
  </b-row>

</template>

<script>
import {
  BRow, BCol, BFormTextarea, BCard, BFormRadio, BTab, BTabs, BButton,
} from 'bootstrap-vue'

import Company from '../components/Company.vue'
import ComplainDetail from '../components/ComplainDetail.vue'
import BasicDetail from '../components/BasicDetail.vue'
import BCardActions from '@/@core/components/b-card-actions/BCardActions.vue'
import RightTab from './components/RightTabConsult.vue'
import TabAttachFiles from './components/TabAttachFiles.vue'
import ModalPersonal from './components/ModalPersonal.vue'

export default {
  components: {
    BButton,
    BFormRadio,
    BCard,
    BRow,
    BCol,
    BFormTextarea,
    BTab,
    BTabs,
    Company,
    BasicDetail,
    BCardActions,
    RightTab,
    TabAttachFiles,
    ModalPersonal,
    ComplainDetail,
  },
  data() {
    const complainDatas = [
      {
        id: '1',
        operator: [{
          id: 1, personalId: '1234567890123', fullname: 'นาย ทดสอบ1 นะจ๊ะ', address: '55 ถ.พัฒนาการ ซ.พัฒนาการ 12 แขวง/ตำบล พัฒนาการ เขต/อำเภอ พัฒนาการ กรุงเทพมหานคร 10234', mobile: '082-987-6543', birthDate: '02/01/2540', fax: '-', age: 24, email: 'thitsaran.p@gmail.com',
        },
        {
          id: 2, personalId: '123456789013', fullname: 'นาย ทดสอบ1 นะจ๊ะ', address: '55 ถ.พัฒนาการ ซ.พัฒนาการ 12 แขวง/ตำบล พัฒนาการ เขต/อำเภอ พัฒนาการ กรุงเทพมหานคร 10234', mobile: '082-987-6543', birthDate: '02/01/2540', fax: '-', age: 24, email: 'thitsaran.p@gmail.com',
        }],
        attorney: [{
          id: 1, personalId: '1234567890123', fullname: 'นาย ทดสอบ1 นะจ๊ะ(มอบ)', address: '55 ถ.พัฒนาการ ซ.พัฒนาการ 12 แขวง/ตำบล พัฒนาการ เขต/อำเภอ พัฒนาการ กรุงเทพมหานคร 10234', mobile: '082-987-6543', birthDate: '02/01/2540', fax: '-', age: 24, email: 'thitsaran.p@gmail.com',
        }],
        company: [{
          id: 1, companyId: '123', companyName: 'บริษัท AA', companyDetail: 'ตั้งอยู่ที่ไหน??',
        }],
        details: [{
          id: 1,
          complainDetail: 'ทดสอบร้องเรียน VUE',
          complainMainType: [1, 2],
          complainSubType: [1, 2, 3],
          complainCause: [1, 3, 5],
          complainPlace: [1, 3, 5],
          complainMotive: [1, 5],
          complainPayment: [1, 3],
          isDmediate: false,
        }],
      },
      {
        id: '2',
        operator: [{
          id: 1, personalId: '1234567890555', fullname: 'นาย ทดสอบ2 นะจ๊ะ', address: '55 ถ.พัฒนาการ ซ.พัฒนาการ 12 แขวง/ตำบล พัฒนาการ เขต/อำเภอ พัฒนาการ กรุงเทพมหานคร 10234', mobile: '082-987-6543', birthDate: '02/01/2540', fax: '-', age: 24, email: 'thitsaran.p@gmail.com',
        }],
        attorney: [{
          id: 1, personalId: '1234567890555', fullname: 'นาย ทดสอบ2 นะจ๊ะ(มอบ)', address: '55 ถ.พัฒนาการ ซ.พัฒนาการ 12 แขวง/ตำบล พัฒนาการ เขต/อำเภอ พัฒนาการ กรุงเทพมหานคร 10234', mobile: '082-987-6543', birthDate: '02/01/2540', fax: '-', age: 24, email: 'thitsaran.p@gmail.com',
        }],
        company: [{ id: 1, companyId: '321', companyDetail: 'บริษัท BB' }],
        details: [{
          id: 2,
          complainDetail: 'ทดสอบร้องเรียน VUE2',
          complainMainType: [1, 2],
          complainSubType: [1, 2, 3],
          complainCause: [1, 3, 5],
          complainPlace: [1, 3, 5],
          complainMotive: [1, 5],
          complainPayment: [1, 3],
          isDmediate: true,
        }],
      },
    ]
    const complainEmpty = [{
      id: 0,
      complainDetail: '',
      complainMainType: [],
      complainSubType: [],
      complainCause: [],
      complainPlace: [],
      complainMotive: [],
      complainPayment: [],
      isDmediate: false,
    }]
    const modalPersonalObj = {
      id: 0,
      identity: '',
      title: '',
      name: '',
      lastname: '',
      sex: '',
      dateofbirth: '',
      address: '',
      tumbon: '',
      ampher: '',
      province: '',
      zipcode: '',
      tel: '',
      mobile: '',
      email: '',
      line: '',
    }
    return {
      userType: 'operator',
      DMediateSelected: '0',
      complainId: null,
      complainList: complainDatas,
      complainData: [{}],
      modalPersonal: modalPersonalObj,
      modalPersonalDefault: modalPersonalObj,
    }
  },
  created() {
    if (this.$route.query.id == null) {
      const id = 1
      this.complainId = id
      const res = this.$route.query == null ? [] : this.complainList.filter(d => { if (d.id == id) return d })
      this.complainData = res
    } else {
      const { id } = this.$route.query
      this.complainId = id
      const res = this.$route.query == null ? [] : this.complainList.filter(d => { if (d.id == id) return d })
      this.complainData = res
    }

    // console.log(this.complainId)
    // console.log(this.complainData)
  },
  methods: {
    onDetailBtnAddClicked() {
      console.log()
      console.log('onDetailBtnAddClicked')
      const ids = this.complainData[0].details.map(item => item.id)
      const id = Math.max.apply(Math, ids) + 1
      this.complainData[0].details.push({
        id,
        complainDetail: '',
        complainMainType: [],
        complainSubType: [],
        complainCause: [],
        complainPlace: [],
        complainMotive: [],
        complainPayment: [],
        isDmediate: false,
      })
    },
    onDetailBtnDeleteClicked(id) {
      console.log('onDetailBtnDeleteClicked')
      const index = this.complainData[0].details.map(item => item.id).indexOf(id)
      this.complainData[0].details.splice(index, 1)
    },
    onModalSubmitData(data) {
      const lists = this.userType === 'operator' ? this.complainData[0].operator : this.complainData[0].attorney
      if (data.id <= 0) {
        const ids = lists.map(item => item.id)
        const id = Math.max.apply(Math, ids) + 1
        lists.push({
          id,
          personalId: data.identity,
          fullname: `${data.title} ${data.name} ${data.lastname}`,
          address: `${data.address} ${data.tumbon} ${data.ampher} ${data.province} ${data.zipcode}`,
          mobile: data.mobile,
          birthDate: data.dateofbirth,
          fax: '',
          age: '',
          email: data.email,
        })
      } else {
        const index = lists.map(item => item.id).indexOf(data.id)
        lists[index].personalId = data.identity
        lists[index].fullname = `${data.title} ${data.name} ${data.lastname}`
        lists[index].address = `${data.address} ${data.tumbon} ${data.ampher} ${data.province} ${data.zipcode}`
        lists[index].mobile = data.mobile
        lists[index].birthDate = data.dateofbirth
        lists[index].fax = ''
        lists[index].age = ''
        lists[index].email = data.email
      }
    },
    setDataPersonal(data) {
      const template = this.resetModal()
      const names = data.fullname.length > 0 ? data.fullname.split(' ') : []
      template.id = data.id
      template.identity = data.personalId
      template.title = names.length > 0 ? names[0] : ''
      template.name = names.length > 0 ? names[1] : ''
      template.lastname = names.length > 0 ? names[2] : ''
      template.sex = ''
      template.dateofbirth = data.birthDate
      template.address = data.address
      template.tumbon = ''
      template.ampher = ''
      template.province = ''
      template.zipcode = ''
      template.tel = ''
      template.mobile = data.mobile
      template.email = data.email
      template.line = ''
      return template
    },
    resetModal() {
      return {
        id: 0,
        identity: '',
        title: '',
        name: '',
        lastname: '',
        sex: '',
        dateofbirth: '',
        address: '',
        tumbon: '',
        ampher: '',
        province: '',
        zipcode: '',
        tel: '',
        mobile: '',
        email: '',
        line: '',
      }
    },
    personalModalClicked(type, id) {
      console.log('personalModalClicked', type, id)
      if (id !== -1) {
        // edit case
        const lists = type === 'operator' ? this.complainData[0].operator : this.complainData[0].attorney
        const personal = lists.map(item => {
          if (item.id === id) return item
        })
        const index = lists.map(item => item.id).indexOf(id)

        if (personal.length > 0) {
          // console.log('personal =', personal)
          this.modalPersonal = this.setDataPersonal(personal[index])
        }
      } else {
        this.modalPersonal = this.resetModal()
      }
      this.$refs.modalPersonalComponent.$refs['modal-personal'].show()
    },
    operatorDetailBtnClicked(id) {
      this.userType = 'operator'
      this.personalModalClicked('operator', id)
    },
    operatorBtnClicked() {
      this.userType = 'operator'
      this.personalModalClicked('operator', -1)
    },
    operatorBtnDeleteClicked(id) {
      console.log('operatorBtnDeleteClicked')
      const index = this.complainData[0].operator.map(item => item.id).indexOf(id)
      console.log('index ', index)
      this.complainData[0].operator.splice(index, 1)
    },
    attorneyDetailBtnClicked(id) {
      this.userType = 'attorney'
      this.personalModalClicked('attorney', id)
    },
    attorneyBtnClicked() {
      this.userType = 'attorney'
      this.personalModalClicked('attorney', -1)
    },
    attorneyBtnDeleteClicked(id) {
      console.log('attorneyBtnDeleteClicked')
      const index = this.complainData[0].attorney.map(item => item.id).indexOf(id)
      console.log('index ', index)
      this.complainData[0].attorney.splice(index, 1)
    },
    companyBtnAddClicked() {
      console.log('companyBtnAddClicked')
      const ids = this.complainData[0].company.map(item => item.id)
      console.log('ids', ids)
      const id = Math.max.apply(Math, ids) + 1
      this.complainData[0].company.push({
        id,
        companyId: '',
        companyDetail: '',
      })
    },
    companyBtnDeleteClicked(id) {
      console.log('companyBtnDeleteClicked')
      const index = this.complainData[0].company.map(item => item.id).indexOf(id)
      this.complainData[0].company.splice(index, 1)
    },
    fillCompanyDetail(id, detail) {
      const index = this.complainData[0].company.map(item => item.id).indexOf(id)
      this.complainData[0].company[index].companyDetail = detail
    },
  },
}
</script>

 <style lang="scss" >

</style>
